import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { beforeAfterItems } from "../features/gallery/beforeAfter.data";
import BeforeAfterSlider from "../features/gallery/BeforeAfterSlider";
import useSeo from "../hooks/useSeo";

export default function GalleryPage() {
  const [activeWork, setActiveWork] = useState(null);
  useSeo({
    title: "გალერეა Before/After | Thermo Fix",
    description:
      "ნახე Thermo Fix-ის შესრულებული ნამუშევრები Before/After ფორმატში. სანტექნიკის და გათბობის რეალური პროექტების გალერეა.",
    path: "/gallery",
    keywords:
      "სანტექნიკის ნამუშევრები, before after plumbing, გათბობის მონტაჟის ფოტოები, Thermo Fix gallery",
    image: "/boiler.png",
  });

  const galleryItems = useMemo(() => beforeAfterItems, []);

  return (
    <div className="relative overflow-hidden">
      <Header />

      <section className="mx-auto w-full max-w-6xl px-6 pb-8 pt-16">
        <div className="mb-10 flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#5481be] dark:text-[#89abe0]">
              სრული პორტფოლიო
            </p>
            <h1 className="mt-3 text-3xl font-bold text-[#0f2748] dark:text-[#e5efff] md:text-5xl">
              ყველა დასრულებული ნამუშევარი
            </h1>
          </div>
          <Link
            to="/"
            className="rounded-2xl border border-[#d4e2f5] px-5 py-2 text-sm font-semibold text-[#24466f] transition hover:bg-white dark:border-[#365073] dark:text-[#c9dcf8] dark:hover:bg-[#182b44]"
          >
            უკან დაბრუნება
          </Link>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {galleryItems.map((item, index) => (
            <article
              key={item.id}
              className="premium-card animate-rise p-4"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              <h3 className="mb-4 text-xl font-semibold text-[#0f2748] dark:text-[#e5efff]">{item.title}</h3>
              <BeforeAfterSlider
                before={item.before}
                after={item.after}
                fallbackBefore={item.fallbackBefore}
                fallbackAfter={item.fallbackAfter}
                title={item.title}
                heightClass="h-64"
                onOpen={() => setActiveWork(item)}
              />
            </article>
          ))}
        </div>
      </section>

      <Footer />

      {activeWork && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-[#09162a]/85 p-4"
          role="button"
          tabIndex={0}
          onClick={() => setActiveWork(null)}
          onKeyDown={(event) => event.key === "Escape" && setActiveWork(null)}
        >
          <div
            className="w-full max-w-5xl overflow-hidden rounded-2xl border border-white/20 bg-white dark:border-[#324766] dark:bg-[#13243a]"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b border-[#e6eef9] px-5 py-3 dark:border-[#314762]">
              <p className="text-sm font-semibold text-[#163861] dark:text-[#d5e6ff]">{activeWork.title}</p>
              <button
                type="button"
                onClick={() => setActiveWork(null)}
                className="rounded-lg px-3 py-1 text-sm font-semibold text-[#163861] hover:bg-[#f1f6ff] dark:text-[#d5e6ff] dark:hover:bg-[#1a314e]"
              >
                დახურვა
              </button>
            </div>
            <div className="p-5">
              <BeforeAfterSlider
                before={activeWork.before}
                after={activeWork.after}
                fallbackBefore={activeWork.fallbackBefore}
                fallbackAfter={activeWork.fallbackAfter}
                title={activeWork.title}
                heightClass="h-[70vh]"
              />
            </div>
            <p className="px-5 pb-5 text-sm text-[#5a7294] dark:text-[#aec6e9]">
              გადაიტანე slider რომ შეადარო შედეგი დეტალურად.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
